// list of dietary restriction filters 
export const dietaryRestrictions = [
  {
    cat: 'Dietary Restrictions',
    key: 'vegetarian',
    display: 'Vegetarian'
  },
  {
    cat: 'Dietary Restrictions',
    key: 'vegan',
    display: 'Vegan'
  },
  {
    cat: 'Dietary Restrictions',
    key: 'gluten-free',
    display: 'Gluten Free'
  },
  {
    cat: 'Dietary Restrictions',
    key: 'dairy-free',
    display: 'Dairy Free'
  }, {
    cat: 'Dietary Restrictions',
    key: 'kosher',
    display: 'Kosher'
  },
  {
    cat: 'Dietary Restrictions',
    key: 'keto',
    display: 'Keto'
  },
  {
    cat: 'Dietary Restrictions',
    key: 'soy-free',
    display: 'Soy Free'
  },
  {
    cat: 'Dietary Restrictions',
    key: 'seafood-free',
    display: 'Seafood Free'
  },
  {
    cat: 'Dietary Restrictions',
    key: 'nut-free',
    display: 'Nut Free'
  }
]